import { fetch } from '@/common/js/fetch';
import { getParamByName } from '@/common/js/util';

export function getServerCourseUrl() {
  const mode = process.env.VUE_APP_MODE;
  let url = '';
  switch (mode) {
    case 'online':
      url = '//api-course-online.du.youdao.com/';
      break;
    case 'pre':
      url = '//api-course-pre.du.youdao.com/';
      break;
    default:
      url = '//api-course-test.du.youdao.com/';
      break;
  }
  return url;
}
export function getMathServerUrl () {
  const mode = process.env.VUE_APP_MODE;
  let url = '';
  switch (mode) {
    case 'online':
      url =  '//api-course-online.mathstalents.com/';
      break;
    case 'pre':
      url =  '//api-course-pre.mathstalents.com/';
      break;
    default:
      url =  '//api-course-test.mathstalents.com/';
      break;
  }
  return url
}
function getServerYreadUrl() {
  const mode = process.env.VUE_APP_MODE;
  let url = '';
  switch (mode) {
    case 'online':
      url = '//api-yread-online.du.youdao.com/';
      break;
    case 'pre':
      url = '//api-yread-pre.du.youdao.com/';
      break;
    default:
      url = '//api-yread-test.du.youdao.com/';
      break;
  }
  return url;
}
export function getCourseUrl() {
  const mode = process.env.VUE_APP_MODE;
  let url = '';
  switch (mode) {
    case 'online':
      url = '//ke.du.youdao.com/';
      break;
    case 'pre':
      url = '//ke-pre.du.youdao.com/';
      break;
    default:
      url = '//ke-test.du.youdao.com/';
      break;
  }
  return url;
}

export function getMathHomeUrl() {
  const mode = process.env.VUE_APP_MODE;
  let url = '';
  switch (mode) {
    case 'online':
      url = '//mathstalents.com/';
      break;
    case 'pre':
      url = '//pre.mathstalents.com/';
      break;
    default:
      url = '//test.mathstalents.com/';
      break;
  }
  return url;
}

export const serverCourseUrl = getServerCourseUrl();

export const serverYreadUrl = getServerYreadUrl();
export const mathServerUrl = getMathServerUrl();
export const mathHomeUrl = getMathHomeUrl();

export function passLogin(username, password,isTeacherLogin) {
  let url = isTeacherLogin ? 'v1/user/pass/teacher/login' : 'v1/user/pass/login';
  return fetch(
    `${serverYreadUrl}${url}`,
    // `https://api-yread-test.du.youdao.com/v1/user/pass/login`,
    {
      username,
      password
    },
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    },
  )
}

export function getUserLoginStatus() {
  return fetch(`${serverCourseUrl}v1/user/status`,);
}

export function exitUser() {
  let url = location.href;
  if (location.pathname.indexOf('noPermission') > -1) {
    const from = getParamByName('from');
    if (from) {
      url = `${location.origin}${from}`;
    } else {
      url = location.origin;
    }
  }

  // 判断是否是移动端页面（通过路径包含 mobileIndex 判断）
  const isMobile = location.pathname.indexOf('mobileIndex') !== -1;
  const isTeacher = url.indexOf('teacher') !== -1;

  // if (url.indexOf("?") > -1) {
  //   url = `${url}&loginBack=true`;
  // } else {
  //   url = `${url}?loginBack=true`;
  // }
  if(url.indexOf('courseDetail') !== -1) {
    url = `${location.origin}/contentIndex`  // 在课程学习视频页退出之后重新登录需要进入到课程列表页
  }

  const baseUrl  = process.env.VUE_APP_MODE === 'online' ? '/' : '/';

  // 移动端跳转到移动端登录页，PC端跳转到PC端登录页
  let loginUrl;
  if (isMobile) {
    loginUrl = `${baseUrl}mobileIndex.html#/mobileLogin`;
  } else {
    loginUrl = isTeacher ? `${baseUrl}teacher/login` : `${baseUrl}login`;
  }

  localStorage.removeItem('authHeader');
  setTimeout(() => {
    window.location.href =
        "https://account.mathstalents.com/login/acc/se/reset?product=DICT&ru=" +
        encodeURIComponent(`${location.origin}${loginUrl}?redirect=${encodeURIComponent(url)}`);
  })
}

/**
 * @param refresh 是否需要刷新服务器时间
 * */
let systemTimePromise;
export function getSystemTime(refresh=false) {
  if (typeof window.TIME_DIFF === 'number' && !refresh) {
    return Promise.resolve(Date.now() - window.TIME_DIFF);
  }

  if (systemTimePromise && !refresh) {
    return systemTimePromise;
  }
  systemTimePromise = fetch(`${serverCourseUrl}v1/system/server/time`).then(res => {
    if (res?.body?.timestamp) {
      const time = res.body.timestamp;
      window.TIME_DIFF = Date.now() - time;
      return time;
    }
    return Date.now();
  }).finally(() => {
    systemTimePromise = null;
  });

  return systemTimePromise;
}
/**
 * 获取服务器系统时间同步接口，需要晚于上面接口调用
 * 如果 window.TIME_DIFF 已经存在，则直接返回本地时间减去时间差
 * 否则通过
 * @returns {number} 返回服务器当前时间的时间戳（毫秒）
 */

export function getSystemTimeSync() {
  if (typeof window.TIME_DIFF === 'number') {
    return Date.now() - window.TIME_DIFF;
  }
  return Date.now();
}